(function () {
  if (window.__booleyDiscountFilter) return;
  window.__booleyDiscountFilter = true;

  const RANGES = ['0-10', '10-20', '20-30', '30-40', '40-50', '50+'];
  const LEGACY_FIFTY_PLUS = ['50-60', '60-70', '70-80', '80-90', '90-100'];
  const cardCache = new Map();
  const listCache = { key: '', products: null };
  const listInflight = new Map();

  let generation = 0;
  let applying = false;
  let observer = null;

  function root() {
    return document.querySelector('[data-discount-filter]');
  }

  function currentRange() {
    const params = new URLSearchParams(window.location.search);
    let value = params.get('discount') || '';
    if (LEGACY_FIFTY_PLUS.indexOf(value) !== -1) {
      const url = new URL(window.location.href);
      url.searchParams.set('discount', '50+');
      window.history.replaceState(null, '', url);
      value = '50+';
    }
    return RANGES.indexOf(value) === -1 ? '' : value;
  }

  function rangeLabel(range) {
    const link = document.querySelector(`[data-discount-range="${range}"]`);
    return link?.getAttribute('data-discount-label') || range;
  }

  async function syncRangeVisibility() {
    try {
      const products = await loadProducts(filterKey());
      const counts = {};
      products.forEach((product) => {
        if (!product.bucket) return;
        counts[product.bucket] = (counts[product.bucket] || 0) + 1;
      });
      document.querySelectorAll('[data-discount-range]').forEach((link) => {
        const item = link.closest('li');
        if (!item) return;
        item.hidden = !counts[link.getAttribute('data-discount-range')];
      });
    } catch (error) {
      console.error(error);
    }
  }

  function pageSize() {
    const size = parseInt(root()?.getAttribute('data-page-size') || '36', 10);
    return size > 0 ? size : 36;
  }

  function currentPage() {
    const page = parseInt(new URLSearchParams(window.location.search).get('dpage') || '1', 10);
    return page > 0 ? page : 1;
  }

  function productsGrid() {
    return document.querySelector('[data-products-grid]');
  }

  function productList() {
    return document.querySelector('[data-products-grid] .js-grid');
  }

  function filterKey() {
    const params = new URLSearchParams(window.location.search);
    ['discount', 'dpage', 'page', 'section_id'].forEach((key) => params.delete(key));
    return params.toString();
  }

  function urlWithoutDiscount() {
    const url = new URL(window.location.href);
    ['discount', 'dpage', 'page', 'section_id'].forEach((key) => url.searchParams.delete(key));
    const search = url.searchParams.toString();
    return url.pathname + (search ? `?${search}` : '');
  }

  function pageUrl(page) {
    const url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    if (page <= 1) url.searchParams.delete('dpage');
    else url.searchParams.set('dpage', String(page));
    const search = url.searchParams.toString();
    return url.pathname + (search ? `?${search}` : '');
  }

  async function fetchDataPage(page, params) {
    const endpoint = root()?.getAttribute('data-collection-url');
    if (!endpoint) return { pages: 1, products: [] };
    const query = new URLSearchParams(params);
    query.set('view', 'discount-data');
    query.set('page', String(page));
    const response = await fetch(`${endpoint}?${query.toString()}`);
    if (!response.ok) throw new Error('Could not load outlet products');
    return response.json();
  }

  function loadProducts(key) {
    if (listCache.key === key && listCache.products) return Promise.resolve(listCache.products);
    if (listInflight.has(key)) return listInflight.get(key);

    const params = new URLSearchParams(key);
    const promise = (async () => {
      const first = await fetchDataPage(1, params);
      const products = [...(first.products || [])];
      const pageCount = first.pages || 1;
      for (let page = 2; page <= pageCount; page += 4) {
        const numbers = [];
        for (let number = page; number < page + 4 && number <= pageCount; number += 1) numbers.push(number);
        const batches = await Promise.all(numbers.map((number) => fetchDataPage(number, params)));
        batches.forEach((batch) => products.push(...(batch.products || [])));
      }
      listCache.key = key;
      listCache.products = products;
      listInflight.delete(key);
      return products;
    })().catch((error) => {
      listInflight.delete(key);
      throw error;
    });

    listInflight.set(key, promise);
    return promise;
  }

  async function fetchCard(handle) {
    if (cardCache.has(handle)) return cardCache.get(handle);
    const productRoot = (root()?.getAttribute('data-product-root') || '').replace(/\/$/, '');
    const response = await fetch(`${productRoot}/products/${encodeURIComponent(handle)}?view=discount-card`);
    if (!response.ok) return '';
    const html = await response.text();
    if (!html.includes('product-grid-item')) return '';
    cardCache.set(handle, html);
    return html;
  }

  async function fetchCards(products) {
    const html = new Array(products.length);
    const chunk = 6;
    for (let index = 0; index < products.length; index += chunk) {
      const slice = products.slice(index, index + chunk);
      const rendered = await Promise.all(slice.map((product) => fetchCard(product.handle)));
      rendered.forEach((markup, offset) => {
        html[index + offset] = markup;
      });
    }
    return html.filter(Boolean);
  }

  function markActive(range) {
    document.querySelectorAll('[data-discount-range]').forEach((link) => {
      const selected = link.getAttribute('data-discount-range') === range;
      link.classList.toggle('is-active', selected);
      if (selected) link.setAttribute('href', urlWithoutDiscount());
    });
    document.querySelectorAll('[data-discount-count]').forEach((count) => {
      count.hidden = !range;
    });
  }

  function formatCount(count) {
    const filter = root();
    const template = count === 1 ? filter?.getAttribute('data-count-one') : filter?.getAttribute('data-count-other');
    if (!template) return `<strong>${count}</strong> products`;
    return template.replace('__COUNT__', String(count)).replace('**', '<strong>').replace('**', '</strong>');
  }

  function syncChip(range) {
    const holder = document.querySelector('[data-active-filters]');
    if (!holder) return;
    holder.querySelectorAll('[data-discount-chip], [data-discount-clear]').forEach((node) => node.remove());
    const wrapper = holder.closest('.collection__active__filters__wrapper');
    if (!range) {
      if (!holder.querySelector('a') && wrapper) wrapper.classList.add('is-hidden');
      return;
    }

    if (wrapper) wrapper.classList.remove('is-hidden');
    const others = holder.querySelectorAll('.active__filters__remove');
    if (others.length > 0 && !holder.querySelector('.active__filters__clear')) {
      const clear = document.createElement('a');
      clear.className = 'active__filters__clear';
      clear.href = root()?.getAttribute('data-clear-url') || urlWithoutDiscount();
      clear.setAttribute('data-discount-clear', '');
      clear.textContent = root()?.getAttribute('data-clear-label') || 'Clear Filters';
      holder.prepend(clear);
    }

    const chip = document.createElement('a');
    chip.className = 'active__filters__remove';
    chip.href = urlWithoutDiscount();
    chip.setAttribute('data-discount-chip', '');
    chip.append(document.createTextNode(rangeLabel(range)));
    const mark = document.createElement('span');
    mark.className = 'filter__x';
    mark.textContent = 'X';
    chip.append(mark);
    holder.append(chip);
  }

  function icon(name) {
    const template = document.querySelector('[data-discount-pager-icons]');
    const source = template?.content?.querySelector(`[data-${name}]`);
    return source ? source.innerHTML : '';
  }

  function renderPager(matchedCount, page) {
    const container = productsGrid();
    if (!container) return;
    container.querySelectorAll('.discount-filter-pager').forEach((node) => node.remove());
    const size = pageSize();
    const pages = Math.ceil(matchedCount / size);
    if (pages <= 1) return;

    const items = [];
    const pushPage = (number) => {
      if (number === page) {
        items.push(`<li class="pagination-custom__num active"><span><span>${number}</span></span></li>`);
      } else {
        items.push(`<li class="pagination-custom__num"><a href="${pageUrl(number)}">${number}</a></li>`);
      }
    };

    const windowStart = Math.max(1, page - 2);
    const windowEnd = Math.min(pages, page + 2);
    if (windowStart > 1) {
      pushPage(1);
      if (windowStart > 2) items.push('<li class="pagination-custom__num pagination-custom__num--dots"><span>&hellip;</span></li>');
    }
    for (let number = windowStart; number <= windowEnd; number += 1) pushPage(number);
    if (windowEnd < pages) {
      if (windowEnd < pages - 1) items.push('<li class="pagination-custom__num pagination-custom__num--dots"><span>&hellip;</span></li>');
      pushPage(pages);
    }

    const pager = document.createElement('div');
    pager.className = 'text-center discount-filter-pager';
    pager.innerHTML = `<ul class="pagination-custom">
      <li class="${page > 1 ? '' : 'disabled '}pagination-custom__arr">${page > 1 ? `<a href="${pageUrl(page - 1)}">${icon('prev')}</a>` : `<span>${icon('prev')}</span>`}</li>
      <li class="pagination-custom__spacer"><span>&#8203;</span></li>
      ${items.join('')}
      <li class="pagination-custom__spacer"><span>&#8203;</span></li>
      <li class="${page < pages ? '' : 'disabled '}pagination-custom__arr">${page < pages ? `<a href="${pageUrl(page + 1)}">${icon('next')}</a>` : `<span>${icon('next')}</span>`}</li>
    </ul>`;
    container.append(pager);
  }

  function updateCount(count) {
    const countEl = document.querySelector('[data-products-count]');
    if (countEl) countEl.innerHTML = formatCount(count);
  }

  async function apply() {
    const range = currentRange();
    markActive(range);
    syncChip(range);
    document.documentElement.classList.toggle('discount-filter-active', Boolean(range));
    syncRangeVisibility();

    const grid = productList();
    if (!range) {
      document.documentElement.classList.remove('discount-filter-pending');
      if (grid) grid.removeAttribute('data-discount-applied');
      return;
    }
    if (!grid || grid.getAttribute('data-discount-applied') === window.location.search) {
      if (!productsGrid()?.classList.contains('is-loading')) {
        document.documentElement.classList.remove('discount-filter-pending');
      }
      return;
    }

    const gen = ++generation;
    applying = true;
    const container = productsGrid();
    container?.classList.add('is-loading');
    document.documentElement.classList.add('discount-filter-pending');

    try {
      const products = await loadProducts(filterKey());
      if (gen !== generation) return;
      const matched = products.filter((product) => product.bucket === range);
      const size = pageSize();
      const pages = Math.max(1, Math.ceil(matched.length / size));
      const page = Math.min(currentPage(), pages);
      const slice = matched.slice((page - 1) * size, page * size);
      const cards = await fetchCards(slice);
      if (gen !== generation) return;

      const list = productList();
      if (!list) return;
      if (cards.length) {
        list.innerHTML = cards.join('');
      } else {
        const emptyText = root()?.getAttribute('data-empty-text') || 'Sorry, there are no products in this collection';
        list.innerHTML = '<div class="js-grid__full-row"><p></p></div>';
        list.querySelector('p').textContent = emptyText;
      }
      list.setAttribute('data-discount-applied', window.location.search);
      renderPager(matched.length, page);
      updateCount(matched.length);
    } catch (error) {
      console.error(error);
      const list = productList();
      if (list) list.removeAttribute('data-discount-applied');
    } finally {
      if (gen === generation) {
        applying = false;
        productsGrid()?.classList.remove('is-loading');
        document.documentElement.classList.remove('discount-filter-pending');
      }
    }
  }

  function schedule() {
    window.clearTimeout(schedule.timer);
    schedule.timer = window.setTimeout(apply, 40);
  }

  function init() {
    if (observer || !productsGrid()) return;
    observer = new MutationObserver(() => {
      if (applying) return;
      schedule();
    });
    observer.observe(productsGrid(), { childList: true });

    document.addEventListener('input', (event) => {
      if (event.target.closest('[data-sidebar-filter-form]') && currentRange()) {
        document.documentElement.classList.add('discount-filter-pending');
      }
    }, true);

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-discount-range]');
      if (!link) return;
      if (link.getAttribute('data-discount-range') !== currentRange()) return;
      event.preventDefault();
      window.location.href = urlWithoutDiscount();
    });

    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
